import DOMPurify from "dompurify";
import { X, Mail, Lock, AlertTriangle } from "lucide-react";

/**
 * Iter107 — Modal d'apercu email avant envoi.
 * Affiche EXACTEMENT le contenu qui sera envoye au client.
 */
export default function EmailPreviewModal({ preview, mode, onClose }) {
  if (!preview) return null;
  const isCustom = mode === "custom";

  return (
    <div
      className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
      data-testid="email-preview-modal"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <div className="flex items-center gap-2">
            <Mail className="w-5 h-5 text-blue-600" />
            <h3 className="font-semibold text-gray-900">Apercu de l'email</h3>
            {isCustom ? (
              <span className="ml-2 inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded bg-amber-100 text-amber-800 font-medium">
                <AlertTriangle className="w-3 h-3" /> Mode personnalise
              </span>
            ) : (
              <span className="ml-2 inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded bg-emerald-100 text-emerald-800 font-medium">
                <Lock className="w-3 h-3" /> Mode generique (securise)
              </span>
            )}
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
            data-testid="email-preview-close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Headers email */}
        <div className="px-5 py-3 border-b bg-gray-50 text-sm space-y-1">
          <div className="flex gap-2">
            <span className="text-gray-500 font-medium w-20">De :</span>
            <span data-testid="preview-from">{preview.from_email || "—"}</span>
          </div>
          <div className="flex gap-2">
            <span className="text-gray-500 font-medium w-20">Repondre a :</span>
            <span data-testid="preview-reply-to">{preview.reply_to || "—"}</span>
          </div>
          <div className="flex gap-2">
            <span className="text-gray-500 font-medium w-20">A :</span>
            <span data-testid="preview-to">{preview.to || "(client sans email)"}</span>
          </div>
          <div className="flex gap-2">
            <span className="text-gray-500 font-medium w-20">Sujet :</span>
            <span className="font-semibold" data-testid="preview-subject">{preview.subject}</span>
          </div>
        </div>

        {/* Body HTML render */}
        <div className="flex-1 overflow-y-auto p-5">
          <div className="text-xs text-gray-500 mb-2 uppercase tracking-wide">
            Contenu envoye au client
          </div>
          <div
            className="border rounded-lg p-4 bg-white"
            data-testid="preview-body"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(preview.html || "", { FORBID_TAGS: ["script", "iframe", "object", "embed"], FORBID_ATTR: ["onerror", "onload"] }) }}
          />
        </div>

        <div className="px-5 py-3 border-t bg-gray-50 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-[#072354] text-white text-sm font-medium hover:bg-[#0a2d6e]"
            data-testid="email-preview-ok"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}
